// @flow

import { showIEDeprecationFlagIfNeeded } from '@atlassian/mpac-ui';
import { initSentry } from '@atlassian/mpac-utils';
import ReactDOM from 'react-dom';
import { setConfiguration as setReadGridSystemConfig } from 'react-grid-system';

import { getApp } from '.';
import { AMKT_FRONTEND_RELEASE_VERSION } from './app/constants';
import startAMKTTelemetry from './app/telemetry/start-telemetry';
import { initMetalMonitoring } from './app/utils/metalMonitoring';
import buildBootstrapData from './bootstrap/buildBootstrapData';
import renderBrowserSupportBanner from './common/components/BrowserSupportBanner';
import registerClicktaleEvents from './common/utils/analytics/clicktale';

import type { BootstrapConfig } from '../application-config/types/BootstrapConfig';

const config: BootstrapConfig = window.bootstrap;
const container = document.getElementById('amkt-frontend-content');

// Initialize error monitoring using Sentry
initSentry({
  dsn: config.sentry.dsn,
  environment: config.sentry.environment,
  releaseVersion: AMKT_FRONTEND_RELEASE_VERSION,
  setupGlobalListeners: true,
});

setReadGridSystemConfig({ maxScreenClass: 'xl' });

showIEDeprecationFlagIfNeeded();
renderBrowserSupportBanner('browser-support-banner');

// Initialize performance monitoring using Metal
initMetalMonitoring({
  id: config.metal.id,
  env: config.metal.env,
  version: 'AMKT_FRONTEND_STATIC',
});

// Initialize analytics
const initAnalytics = (bootstrap: BootstrapConfig) => {
  if (!window.ace) return;

  window.ace.analytics.Initializer.initWithPageAnalytics(
    bootstrap.analytics.aceAnalytics.writeKey,
    {
      featureFlags: bootstrap.featureFlags,
      poweredBy: 'AMKT_FRONTEND',
      gasv3Product: 'marketplace',
    }
  );
};

const initApp = (bootstrap: BootstrapConfig) => {
  startAMKTTelemetry(container, bootstrap, AMKT_FRONTEND_RELEASE_VERSION);
  initAnalytics(bootstrap);

  const app = getApp(bootstrap);

  if (container) {
    ReactDOM.render(app, container);
  }

  if (bootstrap.clicktaleId) {
    registerClicktaleEvents(bootstrap.clicktaleId);
  }
};

buildBootstrapData(config)
  .then(initApp)
  .catch(error => console.error('Failed to bootstrap the application', error));
